/**
 * Builds a URL-safe fragment id from visible heading text (blog TOC anchors).
 * Non-Latin text may collapse to a generic base; callers should dedupe with suffixes.
 */
export const slugifyBlogHeadingForId = (raw: string): string => {
  const trimmed = raw.trim();
  if (!trimmed) return 'section';

  const asciiish = trimmed
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return asciiish.length > 0 ? asciiish : 'section';
};
